import React, { Component } from "react";
import { connect } from "react-redux";
import "react-dates/initialize";
import { SingleDatePicker } from "react-dates";
import "react-dates/lib/css/_datepicker.css";
import moment from "moment";
import Auto from "../autocomplete/autocomplete";
import { apiUrl } from "../common/constants";
import {
  findKey,
  getRevDate,
  getDateForSrch,
  fetchGet,
} from "../../common/common";
import {
  updatePackageData,
  updatePackageCity,
  updatePackageCategory,
  updatePackageTour
  } from "../../actions/search-actions";
import store from "../../store";
import { renderImg } from "../common/icons/img";
import { t, STARTING_FROM, GOING_TO, JOURNEY_DATE, RETURN_DATE, SINGLE_LADY, MODIFY, CHO0SE_DATE, OPTIONAL } from "../../translations/Modify";
import { getSearchParams } from "../common/helper";

class SearchTourModify extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showLoader: false,
      packageData:[],
      from:this.props.search.searchParams.fromCity.split("|")[1],
      tourCategoryId:this.props.search.searchParams.tourCategory,
      tourPackageId: this.props.search.searchParams.tourPackage,
      tourCategoryName:'All',
      tourPackageName:'All',
      filterTourCategory:['All'],
      filterPackageTour:['All'],
      focused: false,
      retFocused: false,
      fromErr: false,
      toErr: false,
      depErr: false,
      depDate: moment(
        new Date(getRevDate(this.props.search.searchParams.jDate))
      ),
      alerterror: "",
    };
  }
  
  componentDidMount() {
       const that = this;
       const data = this.props.data;
       const {from,tourCategoryName,tourCategoryId,tourPackageId} = that.state;
       if(tourCategoryId == 0){
         this.setState({tourCategoryName:'All'})
       }
       if(tourPackageId == 0){
         this.setState({tourPackageName:'All'})
       }

       if(tourCategoryId > 0){
        if(data.length > 0){
          const filterData = data.filter(el => el.TourCategoryId == tourCategoryId);
          if(filterData.length > 0){
            this.setState({tourCategoryName:filterData[0].TourCategory})
          }
        }
       }

       if(tourPackageId > 0){
        if(data.length > 0){
          const filterData = data.filter(el => el.PackageId == tourPackageId);
          if(filterData.length > 0){
            this.setState({tourPackageName:filterData[0].TourPackageName})
          }
        }
       }
       this.parseCity(data);
       this.parseCategory(data);
       this.parsePackageList(data);
       this.setState({packageData :data})
       
       setTimeout(()=>{
        that.filterCategory(from);
        that.filterTourPackage(tourCategoryName,from);
       },100)
 }


parseCity = (data) =>{
  // const citySet = [...new Set(data.map(el => el.FromCity))];   
  // let cityList = citySet.map(el => ({Name:el,Key:''}));
  // cityList = [{Name:'All',Key:''},...cityList];
  // console.log("cityList",cityList);
  // store.dispatch(updatePackageCity((cityList)))


  const cityListRaw = data
  .map(el => ({
    Name: el.FromCity?.trim() || '',
    Key: el.FromCityKey?.trim() || ''
  }))
  .filter(city => city.Name && city.Key); // remove empty entries

const cityListUnique = cityListRaw.filter((city, index, self) =>
  index === self.findIndex(c => c.Name === city.Name && c.Key === city.Key)
);
const cityList = [{ Name: 'All', Key: '' }, ...cityListUnique];
// console.log("cityList",cityList);
store.dispatch(updatePackageCity((cityList)))

}

parseCategory = (data,type="") =>{
    const categorySet = [...new Set(data.map(el => el.TourCategory))];   
    let categoryList = categorySet.map(el => ({Name:el,Key:''}));
    categoryList = [{Name:'All',Key:''},...categoryList];
    // console.log("categoryList",categoryList);
    this.setState({filterTourCategory:categoryList})
    if(type==""){
      store.dispatch(updatePackageCategory((categoryList)))
    }
}

parsePackageList = (data,type="") =>{
    const packageSet = [...new Set(data.map(el => el.TourPackageName))];   
    let packageSetList = packageSet.map(el => ({Name:el,Key:''}));
    packageSetList = [{Name:'All',Key:''},...packageSetList];
    this.setState({filterPackageTour:packageSetList})
    if(type==""){
      store.dispatch(updatePackageTour((packageSetList)))
    }
}

  getFormattedDateForURL = (dateString) => {
    //dateString = dateString.replace(/-/g, ' '); //firefox doesn't understand hyphens in date
    const d = dateString;
    let day = d.getDate(),
      month = d.getMonth() + 1,
      year = d.getFullYear();

    if (day < 10) day = "0" + day;
    if (month < 10) month = "0" + month;

    return day + "-" + month + "-" + year;
  };

  checkOutsideRange = (param, e) => {
    //console.log("hello");
    let today = new Date(window.today);
    today.setHours(0, 0, 0, 0);
    let ninety = new Date(window.today);
    ninety = ninety.setDate(ninety.getDate() + window.daysForCalendar);
    if (param === "dep") {
      return !(today <= e._d && ninety > e._d);
    } else {
      if (this.state.depDate && this.state.depDate._d) {
        const depDate = this.state.depDate._d;
        return !(depDate <= e._d && ninety > e._d);
      } else {
        return !(today <= e._d && ninety > e._d);
      }
    }
  };


  modifySrch = () => {

    const frCityName = this.state.from;
    const categoryId = this.state.tourCategoryId;
    const packageId = this.state.tourPackageId;
    const departDate = this.state.depDate ? this.state.depDate._d : false;

    const depD = getDateForSrch(departDate);
   
    let url = '';
    if (!frCityName || !departDate) {

      let fromErr = !frCityName ? true : false;
      let depErr = !departDate ? true : false;
      let toErr = (!categoryId || !packageId)? true : false;
      this.setState({ fromErr, depErr,toErr });
      return;

    } else {

      this.setState({showLoader:true});

      const packageData = this.props.data;
      let cityId = '0|All';
      if(frCityName != 'All'){
        const filterData = packageData.filter(el => el.FromCity.trim() == frCityName.trim())[0];
        cityId     = filterData.FromCityID + '|'+frCityName;
      }
      url = "/search_tour_booking?fromCity=" + cityId +
        "&tourCategory=" + categoryId +
        "&tourPackage=" + packageId +
        "&jDate=" + depD;

      window.location.href = url;
    }
  };

  showaertdialogue = () => {
    setTimeout(() => {
      this.setState({ alerterror: "" });
    }, 5000);
    return (
      <div
        className="blacklayer"
        onClick={() => {
          this.setState({ alerterror: "" });
        }}
      >
        <div className="popupbox">
          <div className="alertmsg">{this.state.alerterror}</div>
          <button
            className="alertbuttonok crsrpointer"
            onClick={() => {
              this.setState({ alerterror: "" });
            }}
          >
            OK{" "}
          </button>
        </div>
      </div>
    );
  };

  filterCategory = (val) =>{
    // console.log("value",val);
     const packageData = this.props.data;
     if(val == 'All'){
        this.setState({filterTourCategory:this.props.search.packageCategory})
     }else{
        const filterPackage = packageData.filter(el => (el.FromCity.trim() == val.trim()));
        this.parseCategory(filterPackage,'filter');
     }
  }

  filterTourPackage = (val,fromCity) =>{
    // console.log("val",{val,fromCity});
    const packageData = this.props.data;
    if(val == 'All' && fromCity == 'All'){
       this.setState({filterPackageTour:this.props.search.packageTour})
    }else if(val == 'All' && fromCity != 'All'){
      const filterPackage = packageData.filter(el => (el.FromCity.trim() == fromCity.trim()));
      // console.log("filterPackage",filterPackage);
      this.parsePackageList(filterPackage,'filter');
    }else if(val != 'All' && fromCity == 'All'){
      const filterPackage = packageData.filter(el => (el.TourCategory.trim() == val.trim()));
      // console.log("filterPackage",filterPackage);
      this.parsePackageList(filterPackage,'filter');
    }else{
      const filterPackage = packageData.filter(el => ((el.FromCity.trim() == fromCity.trim()) && (el.TourCategory == val.trim())));
      this.parsePackageList(filterPackage,'filter');
    }
 }

  setFromCity = (val) =>{
     let category = this.state.tourCategoryName;
     this.setState({from:val})
     this.filterCategory(val);
     this.filterTourPackage(category,val);
  }

  setTourCategory = (val) =>{
    let fromCity = this.state.from;
    let {tourCategoryId} = this.state;
    const packageData = this.props.data;
    if(val == 'All'){
      tourCategoryId = 0;
    }else{
      const filterData = packageData.filter(el=> el.TourCategory.trim() == val.trim())
      if(filterData.length > 0){
        tourCategoryId = filterData[0].TourCategoryId;
      }
    }
    this.setState({tourCategoryName:val,tourCategoryId})
    this.filterTourPackage(val,fromCity);
  }

  setTourPackage = (val) =>{
    const packageData = this.props.data;
    let {tourPackageId} = this.state;
    if(val == 'All'){
      tourPackageId = 0;
    }else{
      const filterData = packageData.filter(el=> el.TourPackageName.trim() == val.trim())
      if(filterData.length > 0){
        tourPackageId = filterData[0].PackageId;
      }
    }
    this.setState({tourPackageName:val,tourPackageId})
  }

  render() {
    // console.log("packageData",this.props.search.packageData)
    // console.log("filtertourCat",this.state.filterTourCategory)
    // console.log("filterPackageTour",this.state.filterPackageTour)
    let that = this;
    return (
      <section className="searchformsection">
        {that.state.alerterror !== "" ? that.showaertdialogue() : ""}
        {that.state.showLoader && (
          <div className="show-load">
              <div className="loading">
                  <span></span>
                  <span></span>
                  <span></span>
              </div>
          </div>
        )}
        <div className="searchbar-package">
          <Auto
            className="Fromcity cityinput"
            list={this.props.search.packageCity}
            placeholder="Select From City"
            value={this.state.from}
            setValue={this.setFromCity}
            err={this.state.fromErr}
            label="From City"
            inputpadding="34px 15px 17px 23px"
            spanclassname="mod-clear flex-vc"
          />
          <Auto
            className="TourCategory cityinput"
            list={this.state.filterTourCategory}
            placeholder="Select Tour Category"
            value={this.state.tourCategoryName}
            setValue={this.setTourCategory}
            err={this.state.toErr}
            label="Tour Category"
            inputpadding="30px 15px 10px 25px"
            spanclassname="mod-clear flex-vc"
          />
          <Auto
            className="PackageTour cityinput"
            list={this.state.filterPackageTour}
            placeholder="Select Package Tour"
            value={this.state.tourPackageName}
            setValue={this.setTourPackage}
            err={this.state.toErr}
            label="Package Tour"
            inputpadding="30px 15px 10px 25px"
            spanclassname="mod-clear flex-vc"
          />
          <div
            className={
              this.state.depErr ? "mo-inp err cityinput" : "mo-inp cityinput"
            }
          >
            <SingleDatePicker
              id="onwardjdate"
              readOnly={true}
              date={this.state.depDate} // momentPropTypes.momentObj or null
              onDateChange={(depDate) =>
                this.setState({ depDate })
              } // PropTypes.func.isRequired
              focused={this.state.focused} // PropTypes.bool
              onFocusChange={({ focused }) => this.setState({ focused })} // PropTypes.func.isRequired
              hideKeyboardShortcutsPanel={true}
              block={true}
              numberOfMonths={2}
              noBorder={true}
              displayFormat="ddd MMM  DD YYYY"
              placeholder="Choose date"
              isOutsideRange={(event) => this.checkOutsideRange("dep", event)}
              anchorDirection="left"
              firstDayOfWeek={0}
              // isDayBlocked={this.isDayBlocked}
            />
            <span className="mod-clear calendar">
              {renderImg('CalendarIconGray')}
            </span>
            <label>{t(JOURNEY_DATE)}</label>
          </div>
          <div className="modifybutton" onClick={this.modifySrch}>
            {t(MODIFY)}
          </div>
        </div>
        <div className="darklayer"></div>
      </section>
    );
  }
}

const mapStateToProps = function (store) {
  return store;
};

export default connect(mapStateToProps)(SearchTourModify);